
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ozempic-chatbot",
      function () {
        return require("private-next-pages/ozempic-chatbot.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ozempic-chatbot"])
      });
    }
  